import Action from 'redux/helpers/createAction'
const name = 'appUsage'

export const setUsage = Action(name + '/SET_USAGE', data => ({
  data
}))
export const hitKeywords = Action(name + '/HIT_KEYWORDS', qty => ({
  qty
}))
export const hitCompetitors = Action(name + '/HIT_COMPETITORS', qty => ({
  qty
}))
export const hitKeywordFinder = Action(name + '/HIT_KEYWORD_FINDER', qty => ({
  qty
}))
export const hitBacklinkChecker = Action(name + '/HIT_BACKLINK_CHECKER', qty => ({
  qty
}))
export const hitSerpChecker = Action(name + '/HIT_SERP_CHECKER', qty => ({
  qty
}))
